import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';

export interface CustomCreateButtonProps {
  title: string;
  to: string;
}

export const CustomCreateButton = ({ title, to }: CustomCreateButtonProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(to);
  };

  return (
    <Button
      variant="contained"
      size="medium"
      color="primary"
      startIcon={<AddIcon />}
      onClick={handleClick}
    >
      {title}
    </Button>
  );
};
